import React, { useState } from "react";
import { Images, Check, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

// «Simpan di Galeri» — generated chat media is NOT in the Gallery until the user saves it. refId = "<messageId>:<path|drive_id>".
export function GallerySave({ media, refId, dark = false }) {
  const [busy, setBusy] = useState(false);
  const [saved, setSaved] = useState(!!media.gallery);
  if (!refId || (!media.path && !media.drive_id)) return null;
  if (saved) return <span className={`flex items-center gap-1 rounded-lg px-2 py-1 text-[11px] font-semibold ${dark ? "bg-white/15 text-white/90" : "bg-[#EEF3FF] text-[#2F6BFF]"}`} data-testid="media-gallery-saved"><Check size={11} /> Tersimpan di Galeri</span>;
  const save = async () => {
    setBusy(true);
    try { await api.post("/gallery/save", { id: refId }); media.gallery = true; setSaved(true); toast.success("Tersimpan di Galeri"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Gagal menyimpan ke Galeri"); } finally { setBusy(false); }
  };
  return (
    <button type="button" onClick={save} disabled={busy} title="Simpan ke Galeri (tidak otomatis)" data-testid="media-save-gallery"
      className={`flex items-center gap-1 rounded-lg px-2 py-1 text-[11px] font-semibold transition disabled:opacity-60 ${dark ? "bg-white/15 text-white hover:bg-white/25" : "bg-[#0B132B] text-white hover:bg-[#1c2748]"}`}>
      {busy ? <Loader2 size={11} className="animate-spin" /> : <Images size={11} />} Simpan di Galeri
    </button>
  );
}
